import { Typography, ListItemButton } from '@mui/material';
import CheckY from '../../../../Assets/Images/CheckY.png';
import CheckN from '../../../../Assets/Images/CheckN.png';
import { useDispatch, useSelector } from 'react-redux';
import { PermitActions } from '../../../../Reducer/PermitReducer';

export default function TypeWork() {
  const baseInfo = useSelector((state) => state.permit.baseInfo);
  const codeList = useSelector((state) => state.permit.codeInfo);
  const dispatch = useDispatch();

  const selectedWorkTypes = Array.isArray(baseInfo.workTypes)
    ? baseInfo.workTypes
    : [];

  const handleToggleWorkType = (item) => {
    const isSelected = selectedWorkTypes.includes(item.workType);
    let newWorkTypes;
    let newWorkItemIds;

    if (isSelected) {
      newWorkTypes = selectedWorkTypes.filter((id) => id !== item.workType);
      newWorkItemIds = (baseInfo.workItemIds || []).filter(
        (id) => id !== item.workItemId
      );

      const resetSubItems = (list) =>
        (list || []).map((subItem) =>
          String(subItem.workItemId) === String(item.workItemId)
            ? { ...subItem, itemCheck: '' }
            : subItem
        );

      dispatch(
        PermitActions.setCodeInfo({
          risks: resetSubItems(codeList.risks),
          equips: resetSubItems(codeList.equips),
          preparations: resetSubItems(codeList.preparations),
        })
      );
    } else {
      newWorkTypes = [...selectedWorkTypes, item.workType];
      newWorkItemIds = [...(baseInfo.workItemIds || []), item.workItemId];
    }

    dispatch(
      PermitActions.setBaseInfo({
        workTypes: newWorkTypes,
        workItemIds: newWorkItemIds,
      })
    );
  };

  return (
    <div>
      <p style={{ fontSize: '16px', color: '#939393' }}>
        해당되는 작업종류를 모두 선택해 주세요.
      </p>

      <div style={{ marginBottom: '16px' }}>
        {codeList?.workTypes && codeList.workTypes.length > 0 ? (
          codeList.workTypes.map((item, index) => {
            const isSelected = selectedWorkTypes.includes(item.workType);

            return (
              <ListItemButton
                key={index}
                sx={{
                  mt: 1.25,
                  p: 2,
                  py: 1.5,
                  gap: 1,
                  border: 1,
                  borderRadius: 2.5,
                  borderColor: isSelected ? '#80CB66' : '#E8E8E8',
                  backgroundColor: isSelected ? '#ECF6E8' : '#fff',
                  '&:focus': {
                    outline: 'none',
                    borderColor: isSelected ? '#80CB66' : '#E8E8E8',
                    backgroundColor: isSelected ? '#ECF6E8' : '#fff',
                  },
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
                onClick={() => handleToggleWorkType(item)}
              >
                <Typography sx={{ fontWeight: 'bold' }}>
                  {item.workTypeNm}
                </Typography>
                <img src={isSelected ? CheckY : CheckN} alt="체크" />
              </ListItemButton>
            );
          })
        ) : (
          <div
            style={{ textAlign: 'center', padding: '20px', color: '#939393' }}
          >
            작업 종류를 불러오는 중...
          </div>
        )}
      </div>
    </div>
  );
}
